module.exports = __webpack_public_path__ + "static/img/4.baf6ccda.png";